<template>
    <div class="row">
        <div class="col-sm-12" style="padding-top: 0;padding-bottom: 0;">
            <input type="file" id="files" ref="inputFiles" accept="audio/*,.dss,.ds2" multiple v-on:change="handleFileUploads" />
            <label>Clinic Date:</label>&nbsp;<input type="text" class="form-control form-control-sm" v-model="clinicDate" placeholder="dd/mm/yyyy" />
        </div>
        <div class="col-sm-12 text-center" v-show="uploading">
            <v-progress-linear v-model="uploading_progress"></v-progress-linear>
        </div>
        <div class="col-sm-12">
            <div class="row dictation-grid" style="margin: 0;">
                <div class="col-sm-12 dictation" style="padding-top: 0px;padding-bottom: 0px;" v-for="(file, key) in files" v-bind:key="key">
                    <div class="d-flex bd-highlight">
                        <div class="p-2 bd-highlight">
                            {{key + 1}}.
                        </div>
                        <div class="p-2 flex-grow-1 bd-highlight">{{ file.name }}</div>
                        <div class="p-2 bd-highlight"><button @click="removeFile(key)" style="outline: none;border: none;"><i class="fa fa-times" aria-hidden="true" style="cursor: pointer;color: #dc3545;" title="Remove"></i></button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    //uncomment for vuex state management
    //import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
    import axios from 'axios'
    import moment from 'moment'
    import jQuery from 'jquery'
    let $ = jQuery
    export default {
        //Your local variables for use in the component
        data() {
            return {
                uploading: false,
                uploading_progress: 0,
                clinicDate: moment().format("DD/MM/YYYY"),
                files: [],
            };
        },
        //calculated values, auto reactive
        //functionName: function(){}
        //functionName: { get: function() {}, set: function(value){}}
        computed: {},
        //perform actions, not reactive to variables used
        //functionName: function(arg1,arg2){}
        methods: {
            handleFileUploads() {
                this.files = [];
                this.$refs.inputFiles.files.forEach((file) => {
                    this.files.push(file);
                });
                if (this.onDialogClose) {
                    this.onDialogClose((this.files.length == 0) ? true : false);
                }
            },
            cancelFiles() {
                this.files = [];
                $("#files").val(null);
            },
            openBrowseDialog() {
                $("#files").trigger("click");
            },
            uploadDictations() {
                if (!this.hosID) {
                    this.$alert("Please select an Account first.", "Missing Account", "info");
                    return;
                }
                if (!this.cliID) {
                    this.$alert("Please select a Dictator first.", "Missing Dictator", "info");
                    return;
                }
                let clinicDate = $.trim(this.clinicDate);
                if (clinicDate != '') {
                    if (moment(clinicDate, "DD/MM/YYYY").isValid() == false) {
                        this.$alert("Invalid clinic date. Valid date format is dd/mm/yyyy.", "Invalid Date", "error");
                        return;
                    }
                } else {
                    clinicDate = moment().format("DD/MM/YYYY");
                }

                if (this.onBeforeUpload) {
                    this.onBeforeUpload();
                }
                /* Initialize the form data */

                let formData = new FormData();

                /*
                  Iteate over any file sent over appending the files
                  to the form data.
                */
                for (var i = 0; i < this.files.length; i++) {
                    let file = this.files[i];
                    formData.append('files[' + i + ']', file, file.name);
                }
                formData.append("hosID", this.hosID);
                formData.append("hosShortName", this.hosShortName);
                formData.append("cliID", this.cliID);
                formData.append("clinicDate", moment(clinicDate, "DD/MM/YYYY").format("YYYY/MM/DD"));
                formData.append("recorded", false);
                if (!this.axios.defaults.headers['Authorization'] && this.$store) {
                    this.axios.defaults.headers['Authorization'] = `Bearer ${this.$store.state.token}`;
                }
                this.uploading = true;
                this.uploading_progress = 0;
                axios.post('api/dictation/upload', formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                        maxContentLength: Infinity,
                        maxBodyLength: Infinity,
                        onUploadProgress: (progressEvent) => {
                            this.uploading_progress = parseInt(Math.round((100 * progressEvent.loaded) / progressEvent.total));
                        }
                    }
                ).then(() => {
                    this.files = [];
                    $("#files").val(null);
                    if (this.onAfterUpload) {
                        this.onAfterUpload();
                    }
                }).catch((e) => {
                    this.$alert('Sorry, something went wrong, Please try again');
                    if (this.onErrorUpload) {
                        this.onErrorUpload(e);
                    }
                }).finally(() => {
                    this.uploading = false;
                    this.uploading_progress = 0;
                });
            },
            removeFile(key) {
                let fileArray = Array.from(this.files);
                fileArray.splice(key, 1);
                this.files = fileArray;
                if (this.onDialogClose) {
                    this.onDialogClose((this.files.length == 0) ? true : false);
                }
                if (this.files.length == 0) {
                    $("#files").val(null);
                }
            },
        },
        /*  data passed in from external
        propName: {
            type: Number,
            default: 42,
            required: false
        }
        */
        props: {
            hosID: { type: String, required: false },
            hosShortName: { type: String, required: false},
            cliID: { type: String, required: false},
            onDialogClose: { type: Function },
            onErrorUpload: { type: Function },
            onBeforeUpload: { type: Function },
            onAfterUpload: {type: Function}
        },
        /* other components need
          you need to import the component first
          'component-a': ComponentA,
        */
        components: {}
    };
</script>
<style scoped>
    .row .dictation:first-child {
        margin-top: 0px;
    }

    .dictation > div[class^="col-"] {
        padding: 5px 0 5px 0;
    }

    .dictation > .input-group {
        padding: 5px 0 5px 10px;
    }
</style>